import React, { useState, useEffect, useCallback } from "react";
import { Container, Box, CircularProgress, ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction, List } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  Chip,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  Stepper,
  Step,
  StepLabel,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  FormControl,
  IconButton,
  Menu,useMediaQuery
} from "@material-ui/core";
import { Skeleton, Pagination } from "@material-ui/lab";
import {
  DesktopMac,
  Add,
  FilterList,
  Business,
  Assignment,
  Close,
  Search,
  Block,
  MoreVert,
  BusinessCenter,
  ChevronRight,
  SupervisedUserCircle,
  BusinessCenterOutlined,
  Apartment,
  BusinessCenterTwoTone,
  Store
} from "@material-ui/icons";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import Format from "date-fns/format";
import Empty from "../../../assets/svg/empty.svg";

import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { makeStyles,useTheme } from "@material-ui/styles";
import { AdminService, Validator } from "./../../../utils/web_config";
import { useSnackbar } from "notistack";

import axiosRetry from "axios-retry";
const axios = require("axios");
axiosRetry(axios, { retries: 3 });

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    borderRadius: 15,
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
  card: {
    borderRadius: 15,
  },
}));


function getSteps() {
  return ["Organization info", "Additional info", "Finish"];
}

function Organizations(props) {
  const classes = useStyles();
  const history = useHistory();
        const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));


  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();


  const [accountData, setAccountData] = useState({});

  const [addNewOpen, setAddNewOpen] = useState(false);
  const [addNewOpen2, setAddNewOpen2] = useState(false);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
 const [menuOpen, setMenuOpen] = useState(null);

  const [name, setName] = useState({ value: "", error: "" });
  const [type, setType] = useState({ value: "", error: "" });
  const [phone, setPhone] = useState({ value: "", error: "" });
  const [shortName, setShortname] = useState({ value: "", error: "" });
  const [tin, setTin] = useState({ value: "", error: "" });
  const [email, setEmail] = useState({ value: "", error: "" });
  const [website, setWebsite] = useState({ value: "", error: "" });
  const [address, setAddress] = useState({ value: "", error: "" });
  const [zip, setZip] = useState({ value: "", error: "" });
  const [contractNumber, setContractnumber] = useState({
    value: "",
    error: "",
  });
  const [contractStart, setContractstart] = useState({
    value: new Date(),
    error: "",
  });
  const [contractEnd, setContractend] = useState({
    value: new Date(),
    error: "",
  });
  const [fax, setFax] = useState({ value: "", error: "" });

  const [organizations, setOrganizations] = useState({
    loading: false,
    saving: false,
    page: 0,
    pages: 1,
    count: 20,
    per_page: 20,
    data: [],
  });

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

 
  ///////////////////

  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    getOrganizations(accountData.token);

    if (history.location.state != null) {
      const o = history.location.state.open;
      if (o) {
        setAddNewOpen(true);
        history.replace(history.location.pathname);
      }
    }
  }, []);

  ///////////////////////////////////
  const onNameChange = (event) => {
    if (event.target.value == "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("organizations.forms.hints.org_name")}
          </Translate>
        ),
      });
    } else {
      setName({ value: event.target.value, error: "" });
    }
  };
  const onTypeChange = (event) => {
    if (event.target.value == "") {
      setType({ value: "", error: "Enter organization type here" });
    } else {
      setType({ value: event.target.value, error: "" });
    }
  };
  const onPhoneChange = (event) => {
    if (event.target.value === "") {
      setPhone({ value: "", error: "Enter organization phone here" });
    } else {
      setPhone({ value: event.target.value, error: "" });
    }
  };
  const onShortnameChange = (event) => {
    if (event.target.value === "") {
      setShortname({ value: "", error: "Enter organization shortName here" });
    } else {
      setShortname({ value: event.target.value, error: "" });
    }
  };
  const onTinChange = (event) => {
    if (event.target.value === "") {
      setTin({ value: "", error: "Enter organization tin here" });
    } else {
      setTin({ value: event.target.value, error: "" });
    }
  };
  const onEmailChange = (event) => {
    if (event.target.value === "") {
      setEmail({ value: "", error: "Enter organization email here" });
    } else {
      setEmail({ value: event.target.value, error: "" });
    }
  };
  const onWebsiteChange = (event) => {
    if (event.target.value === "") {
      setWebsite({ value: "", error: "Enter organization website here" });
    } else {
      setWebsite({ value: event.target.value, error: "" });
    }
  };
  const onAddressChange = (event) => {
    if (event.target.value === "") {
      setAddress({ value: "", error: "Enter organization address here" });
    } else {
      setAddress({ value: event.target.value, error: "" });
    }
  };
  const onZipChange = (event) => {
    if (event.target.value === "") {
      setZip({ value: "", error: "Enter organization zip here" });
    } else {
      setZip({ value: event.target.value, error: "" });
    }
  };
  const onContractnumberChange = (event) => {
    if (event.target.value === "") {
      setContractnumber({
        value: "",
        error: "Enter organization contractNumber here",
      });
    } else {
      setContractnumber({ value: event.target.value, error: "" });
    }
  };
  const onContractstartChange = (date) => {
    setContractstart({ value: date, error: "" });
  };
  const onContractendChange = (date) => {
    setContractend({ value: date, error: "" });
  };
  const onFaxChange = (event) => {
    if (event.target.value === "") {
      setFax({ value: "", error: "Enter organization fax here" });
    } else {
      setFax({ value: event.target.value, error: "" });
    }
  };
  
  const onRegisterClick = () => {
    if (name.value === "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("organizations.forms.hints.org_name")}
          </Translate>
        ),
      });
    } else if (email.value === "") {
      setEmail({ value: "", error: "Enter organization email here" });
    } else if (!new Validator().validEmail(email.value)) {
      setEmail({
        value: email.value,
        error: (
          <Translate>
            {({ translate }) =>
              translate("users.forms.hints.user_email_invalid")
            }
          </Translate>
        ),
      });
    } else if (phone.value === "") {
      setPhone({
        value: "",
        error: "Enter organization phone here",
      });
    } else if (address.value === "") {
      setAddress({
        value: "",
        error: "Enter organization address here",
      });
    } else if (shortName.value === "") {
      setShortname({
        value: "",
        error: "Enter organization shortName here",
      });
    } 
    // else if (website.value === "") {
    //   setWebsite({
    //     value: "",
    //     error: "Enter organization website here",
    //   });
    // } else if (tin.value === "") {
    //   setTin({ value: "", error: "Enter organization tin here" });
    // }
    else {
      setActiveStep(1);
    }

    // if (fax.value === "") {
    //   setFax({ value: "", error: "Enter organization fax here" });
    // } else if (zip.value === "") {
    //   setZip({ value: "", error: "Enter organization zip here" });
    // } else if (contractNumber.value === "") {
    //   setContractnumber({
    //     value: "",
    //     error: "Enter organization contract Number here",
    //   });
    // }

    if (contractStart.value === "") {
      setContractstart({
        value: "",
        error: "Enter organization contract Start here",
      });
    } else if (contractEnd.value === "") {
      setContractend({
        value: "",
        error: "Enter organization contract End here",
      });
    } else {
      setActiveStep(2);
      if (activeStep === 2) {
        createOrg();
      }
    }
  };


  

  const getOrganizations = (token, p = 0) => {
    const orgsInstance = axios.create(new AdminService().getHeaders(token));
    setOrganizations({ ...organizations, loading: true, page: p });
    console.log("getting organizations .....");

    orgsInstance
      .get(
        new AdminService().GET_ALL_ORGANIZATIONS +
          "?page=" +
          p +
          "&size=" +
          organizations.per_page
      )
      .then(function (response) {
        setOrganizations({ ...organizations, loading: false });
        const d = response.data;
        setOrganizations({
          ...organizations,
          data: d.data,
          page: d.current_page,
          count: d.total_items,
          pages: d.total_pages,
        });
      })
      .catch(function (error) {
        setOrganizations({ ...organizations, loading: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ///////////////////////////////

  const clearOrgForm = () => {
    setContractend({ value: "", error: "" });
    setContractstart({ value: "", error: "" });
    setContractnumber({ value: "", error: "" });
    setEmail({ value: "", error: "" });
    setFax({ value: "", error: "" });
    setAddress({ value: "", error: "" });
    setName({ value: "", error: "" });
    setType({ value: "", error: "" });
    setPhone({ value: "", error: "" });
    setShortname({ value: "", error: "" });
    setTin({ value: "", error: "" });
    setWebsite({ value: "", error: "" });
    setZip({ value: "", error: "" });
  };

  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const createOrg = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );
    setOrganizations({ ...organizations, saving: true });

    const data = {
      booking_limit: 0,
      contract_end_date: Format(contractEnd.value, ["yyyy-MM-dd HH:mm:ss"]),
      contract_number: contractNumber.value,
      contract_start_date: Format(contractStart.value, ["yyyy-MM-dd HH:mm:ss"]),
      email: email.value,
      fax_number: fax.value,
      full_address: address.value,
      name: name.value,
      organization_type: type.value,
      phone_number: phone.value,
      registration_date: Format(new Date(), ["yyyy-MM-dd HH:mm:ss"]),
      short_name: shortName.value,
      tin: tin.value,
      website: website.value,
      zip_number: zip.value,
      settlement_bank_account: "",
      settlement_bank_account_name: "",
      settlement_bank_code: ""
    };


    createInstance
      .post(new AdminService().CREATE_ORGANIZATION, data)
      .then(function (response) {
        setOrganizations({ ...organizations, saving: false });

        const d = response.data;
        const orgs = organizations.data;
        orgs.unshift(d.data);
        setOrganizations({ ...organizations, data: orgs });
        clearOrgForm();

        notify("success", response.data.message);

        setAddNewOpen(false);
      })
      .catch(function (error) {
        setOrganizations({ ...organizations, saving: false });

        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }

        console.log(error);

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={classes.root}>
       {/* //////////////////////// */}

      <Dialog
        open={addNewOpen2}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth='sm'
        fullWidth
        onClose={()=>setAddNewOpen2(false)}
      >
        <DialogTitle id="alert-dialog-title">{"New organization"}</DialogTitle>
        <DialogContent>
          <List>
            <ListItem button onClick={()=>history.push('operators',{open:true})}>
              <ListItemIcon><BusinessCenter/></ListItemIcon>
              <ListItemText primary='Operator'/>
              <ListItemSecondaryAction>
                <ChevronRight/>
              </ListItemSecondaryAction>
            </ListItem>

            {/* <ListItem button onClick={()=>{
                
                setType({value:'OPERATOR_AGENCY',error:''})
                setAddNewOpen(true)
                setAddNewOpen2(false)
              }}>
              <ListItemIcon><BusinessCenterTwoTone/></ListItemIcon>
              <ListItemText primary='Operator agency'/>
              <ListItemSecondaryAction>
                <ChevronRight/>
              </ListItemSecondaryAction>
            </ListItem> */}

            <ListItem button onClick={()=>{
                
                setType({value:'INTEGRATION_OPERATOR',error:''})
                setAddNewOpen(true)
                setAddNewOpen2(false)
              }}>
              <ListItemIcon><BusinessCenterOutlined/></ListItemIcon>
              <ListItemText primary='Integration operator'/>
              <ListItemSecondaryAction>
                <ChevronRight/>
              </ListItemSecondaryAction>
            </ListItem>

            <ListItem button onClick={()=>{
                
                setType({value:'COOPERATIVE',error:''})
                setAddNewOpen(true)
                setAddNewOpen2(false)
              }}>
              <ListItemIcon><Store/></ListItemIcon>
              <ListItemText primary='COOPERATIVE'/>
              <ListItemSecondaryAction>
                <ChevronRight/>
              </ListItemSecondaryAction>
            </ListItem>

            <ListItem button onClick={()=>history.push('agents/private',{open:true})}>
              <ListItemIcon><SupervisedUserCircle/></ListItemIcon>
              <ListItemText primary='Private agent'/>
              <ListItemSecondaryAction>
                <ChevronRight/>
              </ListItemSecondaryAction>
            </ListItem> 
            <ListItem button>
              <ListItemIcon><Business/></ListItemIcon>
              <ListItemText primary='Stakeholder' onClick={()=>{
                
                setType({value:'STAKEHOLDER',error:''})
                setAddNewOpen(true)
                setAddNewOpen2(false)
              }}/>
              <ListItemSecondaryAction>
                <ChevronRight/>
              </ListItemSecondaryAction>
            </ListItem>
            
            <ListItem button onClick={()=>{
                
                setType({value:'RURA',error:''})
                setAddNewOpen(true)
                setAddNewOpen2(false)
              }}>
              <ListItemIcon><Apartment/></ListItemIcon>
              <ListItemText primary='RURA'/>
              <ListItemSecondaryAction>
                <ChevronRight/>
              </ListItemSecondaryAction>
            </ListItem>
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setAddNewOpen2(false)
          }} color="primary">
            Close
          </Button>
         
        </DialogActions>
      </Dialog>

{/* New operator dialog */}
<Dialog
          open={addNewOpen}
          maxWidth="sm"
          fullWidth
          onClose={() => setAddNewOpen(false)}
        >
          <DialogTitle id="new-op">
           Create {type.value.replace('_',' ').toLocaleLowerCase()}
          </DialogTitle>
          <DialogContent>
            {/* <Box mt={1} mb={1}>
            <LinearProgress variant="determinate" value={40} />
          </Box> */}

            <Box width={1}>
              <Stepper
                activeStep={activeStep}
                alternativeLabel
                style={{ padding: 0 }}
              >
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <div>
                {activeStep === steps.length ? (
                  <div>
                    <Typography className={classes.instructions}>
                      All steps completed
                    </Typography>
                    <Button>Reset</Button>
                  </div>
                ) : (
                  <div>
                    {activeStep == 0 ? (
                      <Box>
                        <Box mt={3}>
                          <Translate>
                            {({ translate }) => (
                              <TextField
                                size="small"
                                variant="outlined"
                                color="primary"
                                autoComplete="off"
                                value={name.value}
                                placeholder={translate(
                                  "organizations.forms.hints.org_name"
                                )}
                                label={
                                  <Translate id="organizations.forms.labels.org_name" />
                                }
                                fullWidth
                                onChange={onNameChange}
                                helperText={name.error}
                                error={name.error !== ""}
                              />
                            )}
                          </Translate>
                        </Box>
                        <Box mt={2}>
                          <Translate>
                            {({ translate }) => (
                              <TextField
                                size="small"
                                variant="outlined"
                                color="primary"
                                value={email.value}
                                placeholder={translate(
                                  "organizations.forms.hints.org_email"
                                )}
                                label={
                                  <Translate id="organizations.forms.labels.org_email" />
                                }
                                fullWidth
                                onChange={onEmailChange}
                                helperText={email.error}
                                error={email.error !== ""}
                              />
                            )}
                          </Translate>
                        </Box>
                        <Box mt={2}>
                          <Translate>
                            {({ translate }) => (
                              <TextField
                                size="small"
                                variant="outlined"
                                color="primary"
                                value={phone.value}
                                placeholder={translate(
                                  "organizations.forms.hints.org_phone"
                                )}
                                label={
                                  <Translate id="organizations.forms.labels.org_phone" />
                                }
                                fullWidth
                                onChange={onPhoneChange}
                                helperText={phone.error}
                                error={phone.error !== ""}
                              />
                            )}
                          </Translate>
                        </Box>
                        <Box mt={2}>
                          <Translate>
                            {({ translate }) => (
                              <TextField
                                size="small"
                                variant="outlined"
                                color="primary"
                                value={address.value}
                                placeholder={translate(
                                  "organizations.forms.hints.org_address"
                                )}
                                label={
                                  <Translate id="organizations.forms.labels.org_address" />
                                }
                                fullWidth
                                onChange={onAddressChange}
                                helperText={address.error}
                                error={address.error !== ""}
                              />
                            )}
                          </Translate>
                        </Box>
                        <Box mt={2}>
                          <Translate>
                            {({ translate }) => (
                              <TextField
                                size="small"
                                variant="outlined"
                                color="primary"
                                value={shortName.value}
                                placeholder={translate(
                                  "organizations.forms.hints.org_short"
                                )}
                                label={
                                  <Translate id="organizations.forms.labels.org_short" />
                                }
                                fullWidth
                                onChange={onShortnameChange}
                                helperText={shortName.error}
                                error={shortName.error !== ""}
                              />
                            )}
                          </Translate>
                        </Box>
                        {/* <Box mt={2}>
                          <FormControl
                            className={classes.formControl}
                            fullWidth
                            variant="outlined"
                            size="small"
                            error={type.error !== ""}
                          >
                            <InputLabel id="type">
                              <Translate id="organizations.forms.labels.org_type" />
                            </InputLabel>
                            <Select
                              label={
                                <Translate id="organizations.forms.labels.org_type" />
                              }
                              value={type.value}
                              onChange={onTypeChange}
                            >
                              <MenuItem value="CENTRIKA">Centrika</MenuItem>
                              <MenuItem value="OPERATOR">Operator</MenuItem>
                              <MenuItem value="STAKEHOLDER">
                                Stakeholder
                              </MenuItem>
                              <MenuItem value="AGENT">Agent</MenuItem>
                              <MenuItem value="RURA">RURA</MenuItem>
                            </Select>
                            <FormHelperText>{type.error}</FormHelperText>
                          </FormControl>
                        </Box> */}
                        <Box mt={2}>
                          <Translate>
                            {({ translate }) => (
                              <TextField
                                size="small"
                                variant="outlined"
                                color="primary"
                                value={website.value}
                                placeholder={translate(
                                  "organizations.forms.hints.org_website"
                                )}
                                label={
                                  <Translate id="organizations.forms.labels.org_website" />
                                }
                                fullWidth
                                onChange={onWebsiteChange}
                                helperText={website.error}
                                error={website.error !== ""}
                              />
                            )}
                          </Translate>
                        </Box>
                        <Box mt={2}>
                          <Translate>
                            {({ translate }) => (
                              <TextField
                                size="small"
                                variant="outlined"
                                color="primary"
                                value={tin.value}
                                placeholder={translate(
                                  "organizations.forms.hints.org_tin"
                                )}
                                label={
                                  <Translate id="organizations.forms.labels.org_tin" />
                                }
                                fullWidth
                                onChange={onTinChange}
                                helperText={tin.error}
                                error={tin.error !== ""}
                              />
                            )}
                          </Translate>
                        </Box>
                      </Box>
                    ) : activeStep === 1 ? (
                      <Box>
                        <Box mt={3}>
                          <Translate>
                            {({ translate }) => (
                              <TextField
                                size="small"
                                variant="outlined"
                                color="primary"
                                value={fax.value}
                                placeholder={translate(
                                  "organizations.forms.hints.org_fax"
                                )}
                                label={
                                  <Translate id="organizations.forms.labels.org_fax" />
                                }
                                fullWidth
                                onChange={onFaxChange}
                                helperText={fax.error}
                                error={fax.error !== ""}
                              />
                            )}
                          </Translate>
                        </Box>

                        <Box mt={2}>
                          <Translate>
                            {({ translate }) => (
                              <TextField
                                size="small"
                                variant="outlined"
                                color="primary"
                                value={zip.value}
                                placeholder={translate(
                                  "organizations.forms.hints.org_zip"
                                )}
                                label={
                                  <Translate id="organizations.forms.labels.org_zip" />
                                }
                                fullWidth
                                onChange={onZipChange}
                                helperText={zip.error}
                                error={zip.error !== ""}
                              />
                            )}
                          </Translate>
                        </Box>
                        <Box mt={2}>
                          <Translate>
                            {({ translate }) => (
                              <TextField
                                size="small"
                                variant="outlined"
                                color="primary"
                                value={contractNumber.value}
                                placeholder={translate(
                                  "organizations.forms.hints.org_contract_no"
                                )}
                                label={
                                  <Translate id="organizations.forms.labels.org_contract_no" />
                                }
                                fullWidth
                                onChange={onContractnumberChange}
                                helperText={contractNumber.error}
                                error={contractNumber.error !== ""}
                              />
                            )}
                          </Translate>
                        </Box>
                        <Box mt={2}>
                          <DatePicker
                            fullWidth
                            disableToolbar
                            variant="inline"
                            format="yyyy-MM-dd"
                            margin="dense"
                            autoOk
                            id="date-picker-dialog"
                            label={
                              <Translate id="organizations.forms.labels.org_contract_start" />
                            }
                            value={contractStart.value}
                            inputVariant="outlined"
                            onChange={onContractstartChange}
                            InputProps={{
                              disableUnderline: true,
                              style: { paddingRight: 0 },
                            }}
                          />
                        </Box>
                        <Box mt={2}>
                          <DatePicker
                            fullWidth
                            disableToolbar
                            variant="inline"
                            format="yyyy-MM-dd"
                            margin="dense"
                            autoOk
                            id="date-picker-dialog"
                            label={
                              <Translate id="organizations.forms.labels.org_contract_end" />
                            }
                            value={contractEnd.value}
                            inputVariant="outlined"
                            onChange={onContractendChange}
                            InputProps={{
                              disableUnderline: true,
                              style: { paddingRight: 0 },
                            }}
                          />
                        </Box>
                      </Box>
                    ) : (
                      <Box m={4}>
                        <Typography align="center">
                          <Translate id="organizations.forms.dialog_desc" />
                        </Typography>
                      </Box>
                    )}
                  </div>
                )}
              </div>

              <Box mt={3} />
              <DialogActions>
                <Button
                  variant="outlined"
                  color="primary"
                  disableElevation
                  onClick={() => {
                    activeStep === 0 ? setAddNewOpen(false) : handleBack();
                  }}
                >
                  {activeStep === 0 ? (
                    <Translate id="organizations.forms.buttons.cancel" />
                  ) : (
                    <Translate id="organizations.forms.buttons.back" />
                  )}
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  disableElevation
                  disabled={organizations.saving}
                  onClick={() => {
                    onRegisterClick();
                  }}
                >
                  {organizations.saving ? (
                    <CircularProgress size={25} />
                  ) : activeStep === steps.length - 1 ? (
                    <Translate id="organizations.forms.buttons.register" />
                  ) : (
                    <Translate id="organizations.forms.buttons.continue" />
                  )}
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
        </Dialog>
        {/* Dialogs ends here */}

      {/* ////////////////////////// */}
        <Box display="flex" alignItems="center">
          <Box mr={2}>
            <Business color="primary" fontSize="large" />
          </Box>
          <Typography variant="h5" className={classes.title}>
            <b>Organizations</b>
          </Typography>
          <IconButton color="primary">
            <Search />
          </IconButton>


           {!matches ? (
                <>
                  <IconButton onClick={(e) => setMenuOpen(e.currentTarget)}>
                    <MoreVert />
                  </IconButton>
                  <Menu
                    id="menu-appbar"
                    anchorEl={menuOpen}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    open={menuOpen != null}
                    onClose={() => setMenuOpen(null)}
                  >
                    <MenuItem
                        onClick={() => {
            
                     }}
                    >
                     Filter
                    </MenuItem>
                    
               
                  </Menu>
                </>
              ) : (
                  <Box ml={2} display="flex" height={40}>
            <Button
              className={classes.btn}
              color="primary"
              variant="outlined"
              size="medium"
              startIcon={<FilterList />}
              disableElevation
            >
              Filter
            </Button>
           
          </Box>
                )}
        </Box>
        <Box mt={3} />

        <Grid container spacing={2}>
          <Grid item xs={6} sm={4} md={4} lg={2}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
            >
              <CardActionArea
                className={classes.action}
                onClick={() => {
                  setAddNewOpen2(true);
                }}
              >
                <Box
                  height="150px"
                  width={1}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                  border={1}
                  borderStyle="dotted"
                  borderRadius="borderRadius"
                  borderColor="grey.300"
                  className={classes.btn2}
                >
                  <Add fontSize="large" />
                </Box>
              </CardActionArea>
              <Box mt={1}>
                <Typography color="inherit">Add new</Typography>
                <Typography color="textSecondary" variant="caption">
                  New organization
                </Typography>
              </Box>
            </Box>
          </Grid>

          {organizations.length == 0 && !organizations.loading && (
            <Box
              p={2}
              height={1}
              display="flex"
              alignItems="center"
              flexDirection="column"
              justifyContent="center"
            >
              <Box mt={2}>
                <img src={Empty} alt="Empty data" height={160} />
              </Box>
              <Typography color="textSecondary">
                There are no organizations available, create one first
              </Typography>
            </Box>
          )}

          {organizations.loading
            ? Array.from(Array(organizations.per_page).keys()).map((o, i) => (
                <Grid item xs={6} sm={4} md={4} lg={2}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    borderRadius={15}
                    width={1}
                  >
                    <Skeleton
                      variant="rect"
                      height={150}
                      width={"100%"}
                      style={{ borderRadius: 15 }}
                    />

                    <Skeleton
                      variant="text"
                      width={"68%"}
                      style={{ borderRadius: 7 }}
                    />
                    <Skeleton
                      variant="text"
                      width={"45%"}
                      height={8}
                      style={{ borderRadius: 7 }}
                    />
                  </Box>
                </Grid>
              ))
            : organizations.data.map((org, i) => (
                <Grid item xs={6} sm={4} md={4} lg={2}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                  >
                    <CardActionArea
                      className={classes.action}
                      onClick={() => {
                        
                        if(org.organization_type=='OPERATOR'){
                          history.push("/centrika/op/view", org);
                        }else if(org.organization_type=='CENTRIKA'){
                          history.push("/centrika/org/view", org);
                        }else if(org.organization_type=='AGENT'){
                          if (org.agent_code == null) {
                            notify('info', "This agent does not have agent code")
                            return
                          }
                          history.push("/centrika/agents/corp", org);
                        }else{
                          enqueueSnackbar(
                            "Organization don't have details yet.",
                            {
                              variant: "info",
                            }
                          );
                        }

                      
                      }}
                    >
                      <Paper className={classes.card} elevation={0}>
                        <Box
                          height="150px"
                          width={1}
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          flexDirection="column"
                          border={0}
                          borderRadius="borderRadius"
                          borderColor="grey.300"
                        >
                          {org.organization_status == "DISABLED" && (
                            <Box
                              height={1}
                              width={1}
                              p={1}
                              display="flex"
                              justifyContent="flex-end"
                              alignItems="flex-start"
                              style={{ position: "absolute" }}
                            >
                              <Block color="secondary" />
                            </Box>
                          )}

                         <OrgImage id={org.organization_id}/>
                        </Box>
                      </Paper>
                    </CardActionArea>
                    <Box mt={1}>
                      <Typography color="inherit">{org.name}</Typography>
                      <Typography color="textSecondary" variant="caption">
                        {org.organization_type}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
        </Grid>
        <Box width={1} mt={2} display="flex" justifyContent="center">
          <Pagination
            disabled={organizations.loading}
            count={organizations.pages}
            page={organizations.page + 1}
            onChange={(e, v) => {
              getOrganizations(accountData.token, v - 1);
            }}
            size="large"
          />
        </Box>
      </div>
    </MuiPickersUtilsProvider>
  );
}

/////////
/////////////////////////////////////////////////////////////////////////////////////

function OrgImage(props) {
  const [organization, setOrganization] = useState({ status: "loading" });
  const id = props?.id;

  useEffect(() => {
    var accountData = new AdminService().accountData;

    if (organization.data == null) {
      getOrganization(accountData.token);
    }
  }, [organization]);

  const getOrganization = (token) => {
    const gInstance = axios.create(new AdminService().getHeaders(token));

    const url = new AdminService().GET_ORGANIZATION_BY_ID + id;

    gInstance
      .get(url)
      .then(function (response) {
        const d = response.data;
        setOrganization({ data: d.data, status: "success" });
      })
      .catch(function (error) {
        if (error.response) {
          if (error?.response?.status == 404) {
            setOrganization({ data: [], status: "empty" });
          } else {
            setOrganization({ data: [], status: "error" });
          }
        } else {
          setOrganization({ data: [], status: "error" });
        }
      });

    ////
  };

  return( <>
  {organization?.data?.logo_file_byte != null ? (
                          <img alt="icon" src={"data:image/jpg;base64," +organization?.data?.logo_file_byte} width={140} />
                        ) : (
                            <Business fontSize="large" />
                          )}
  </>)
}

export default withLocalize(Organizations);
